module.exports = __webpack_public_path__ + "img/wojewodztwo.f684a32b.jpg";